import React from "react";
import './style.css';

// Custom components
import Navbar from './components/Navbar';
import MainPageContent from './components/MainPageContent';
import Footer from './components/Footer';

const App = () => {
  
  return (
    <div className="App">
      <Navbar />
      <MainPageContent/>
      <Footer />
    </div> 
  );
}
export default App;
